import React, { Component, Fragment } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { Pagination } from 'antd';

import { HolderGrid, Loading } from 'components';

const GridItem = HolderGrid.Item;

const TileView = ({
	loading,
	holders,
	viewMode,
	location: { search },
	page,
	perPage,
	onPageChange,
}) => {
	const min = page * perPage - perPage;
	const max = min + perPage;
	const filtered = holders.filter((h, i) => {
		if (i < max && i >= min) return h;
	});
	return (
		<Fragment>
			<HolderGrid viewMode={viewMode}>
				{loading && <Loading />}
				{filtered.map(item => (
					<GridItem image={item.imagePath} key={item.clientReference}>
						<GridItem.Field>
							<Link
								to={`/directory/${
									item.clientReference
								}${search}`}
							>
								{item.name}
							</Link>
						</GridItem.Field>
						<GridItem.Field>
							ID: {item.clientReference}
						</GridItem.Field>
					</GridItem>
				))}
			</HolderGrid>
			<Pagination
				style={{ float: 'right' }}
				defaultCurrent={1}
				total={holders.length}
				defaultPageSize={10}
				showSizeChanger
				size={'small'}
				current={page}
				pageSize={perPage}
				pageSizeOptions={['25', '50', '100']}
				onChange={(page, pageSize) =>
					onPageChange(`${viewMode}-tile`, page, pageSize)
				}
				onShowSizeChange={(current, size) =>
					onPageChange(`${viewMode}-tile`, 1, size)
				}
			/>
		</Fragment>
	);
};

export default withRouter(TileView);



// WEBPACK FOOTER //
// ./src/pages/directory/contact-list/components/tile-view/index.js